// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://dev-api.passbookapp.in/',
  sasToken: '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-05-10T01:10:57Z&st=2025-06-13T17:10:57Z&spr=https,http&sig=S13EFXN4J4DYC7iBfkXNEu3eyvcHFtjj1aV46G667WA%3D',
  accountName: 'passbookapp',
  containerName: 'dev-lagubandhu',
  domainEndPoint: '.dev.passbookapp.in',
  erpEndPoint: '.devssp.passbookapp.in' 
}